<!-- 停车市场分析数据 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode": "2KKN885S",
                "startDate": "20190910000000",
                "endDate": "20190910235959",
                "vipType": 1,
                "hourArea": "0-1,1-4,4-7,7-10,10-12,12-0"
            },
            responseCode: {
                    "data": {
                        "recordList": [
                            {
                                "hourParkingPercent": 0,
                                "hourParkingTotal": 0,
                                "parkId": "d43770c2-1809-436f-a3d2-d5c52d6347c6",
                                "parkingTime": 0,
                                "parkingTimeString": "<1H",
                                "parkingTotal": 0,
                                "vipParkingTotal": 0,
                                "vipType": 1
                            },
                            {
                                "hourParkingPercent": 0,
                                "hourParkingTotal": 0,
                                "parkId": "d43770c2-1809-436f-a3d2-d5c52d6347c6",
                                "parkingTime": 0,
                                "parkingTimeString": "1-4H",
                                "parkingTotal": 0,
                                "vipParkingTotal": 0,
                                "vipType": 1
                            },
                            {
                                "hourParkingPercent": 0,
                                "hourParkingTotal": 0,
                                "parkId": "d43770c2-1809-436f-a3d2-d5c52d6347c6",
                                "parkingTime": 0,
                                "parkingTimeString": "4-7H",
                                "parkingTotal": 0,
                                "vipParkingTotal": 0,
                                "vipType": 1
                            },
                            {
                                "hourParkingPercent": 0,
                                "hourParkingTotal": 0,
                                "parkId": "d43770c2-1809-436f-a3d2-d5c52d6347c6",
                                "parkingTime": 0,
                                "parkingTimeString": "7-10H",
                                "parkingTotal": 0,
                                "vipParkingTotal": 0,
                                "vipType": 1
                            },
                            {
                                "hourParkingPercent": 0,
                                "hourParkingTotal": 0,
                                "parkId": "d43770c2-1809-436f-a3d2-d5c52d6347c6",
                                "parkingTime": 0,
                                "parkingTimeString": "10-12H",
                                "parkingTotal": 0,
                                "vipParkingTotal": 0,
                                "vipType": 1
                            },
                            {
                                "hourParkingPercent": 0,
                                "hourParkingTotal": 0,
                                "parkId": "d43770c2-1809-436f-a3d2-d5c52d6347c6",
                                "parkingTime": 0,
                                "parkingTimeString": ">12H",
                                "parkingTotal": 0,
                                "vipParkingTotal": 0,
                                "vipType": 1
                            }
                        ]
                    },
                    "message": "业务成功",
                    "resultCode": 0,
                    "status": 1
                }
                ,infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取车场停车时长分析数据",
                t_url: this.commonUrls.test+"parkingTimeAnalyse",
                p_url: this.commonUrls.prod+"parkingTimeAnalyse",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编码' },
                        { info1: 'startDate', info2: '是', info3: 'String', info4: '时间段起始时间，yyyyMMddHHmmss' },
                        { info1: 'endDate', info2: '是', info3: 'String', info4: '时间段结束时间，yyyyMMddHHmmss' },
                        { info1: 'vipType', info2: '是', info3: 'Integer', info4: 'VIP类型（仅支持1和2） 1临时车 2月租车' },
                        { info1: 'hourArea', info2: '是', info3: 'String', info4: '时长间隔，形如：0-1,1-4,4-7,7-10,10-12,12-0。0-1表示小于1小时的区间；1-4表示大于等于1小于4的区间；12-0表示大于等于12小时的区间' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'recordList', info2: '是', info3: 'JSONArray', info4: '记录列表' }
                        ]
                },{
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'id', info2: '是', info3: 'long', info4: '主键ID' },
                        { info1: 'parkId', info2: '是', info3: 'String', info4: '车场uuid' },
                        { info1: 'statDate', info2: '是', info3: 'long', info4: '统计日期' },
                        { info1: 'statDateText', info2: '是', info3: 'String', info4: '统计日期,yyyy-MM-dd' },
                        { info1: 'vipType', info2: '是', info3: 'Integer', info4: 'VIP类型 1临时车 2月租车' },
                        { info1: 'parkingTime', info2: '是', info3: 'Integer', info4: '停车时长（1表示：停车时长<1小时;2表示：1小时<=停车时长<2小时）' },
                        { info1: 'parkingTimeString', info2: '是', info3: 'String', info4: '停车时长（例如：<1H;1-4H;4-7H;7-10H;10-12H;>12H）' },
                        { info1: 'hourParkingTotal', info2: '是', info3: 'Integer', info4: '停车记录数' },
                        { info1: 'vipParkingTotal', info2: '是', info3: 'Integer', info4: '某VIP类型的总记录数' },
                        { info1: 'parkingTotal', info2: '是', info3: 'Integer', info4: '停车总记录数=临时车总记录数+月租车总记录数' },
                        { info1: 'hourParkingPercent', info2: '是', info3: 'Decimal', info4: '停车时长占比=停车记录数/某VIP类型的总记录数' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/dataAnalysis/parkingTimeAnalyse.vue